module.exports = __webpack_public_path__ + "img/16_77.975cba8a.png";